import {FC, useEffect} from 'react';
import Button from '../../../components/UI/Button/Button'
import UpdateTemplateForm from '../../Forms/Lottery/UpdateLotteryTemplate/UpdateOneTimeLotteryTemplate';
import {useParams, useNavigate} from 'react-router-dom';
import {getUpdateTemplateDetail, setUpdateTemplate, updateLotteryTemplate} from '../../../features/updateTemplateSlice';
import {updateLottery} from '../../../features/lotteryListSlice';
import {useSelector, useDispatch} from 'react-redux';
import { RootState } from '../../../app/Store';
import ViewHeader from '../../../components/ViewHeader/ViewHeader';
import {adminRouts} from '../../../routs';

import {Breadcrumbs, DeleteBtn} from './StyledUpdateTemplate';

import {validateCreateOnetimeLottery} from '../../../Utility/formValidation';
import {NotificationType} from '../../../Utility/InterFacesAndEnum';
import {toggleNotificationVisibility} from '../../../features/networkNotification';
import { removeTemplate, setTemplateRemoveStatus } from '../../../features/templateListslice';

enum ButtonSize {
    sm = "small",
    md = "medium",
    lg = "large"
}
enum ButtonVariant {
    primaryFilled = "primary-filled",
    secondary = "secondary",
    primaryLink = "primaryLink"
}

const UpdateOneTimeTemplate:FC = () => {

    const templateObj = useSelector((state: RootState) => state.updateTemplate.templateObj);
    const isTemplateDelete = useSelector((state: RootState) => state.templateList.isTemplateDeleted);
    const updateStatus = useSelector((state:RootState)=>state.updateTemplate.updateStatus);


    const params = useParams();

    const dispatch = useDispatch();
    const navigation = useNavigate();

    const navigateToView = (path:string):void => {
        navigation(path);
    };

    useEffect(()=>{
        if(updateStatus===true){
            navigateToView(`${adminRouts.gamesList}`);
        }
    },[updateStatus])

    useEffect(() => {
        if (isTemplateDelete === true) {
            dispatch(setTemplateRemoveStatus({status:false}));
            navigateToView(`${adminRouts.gamesList}`);
        }
    },[isTemplateDelete]);

    useEffect(() => {
        let {lotteryId} = params;
        dispatch(getUpdateTemplateDetail(lotteryId ? lotteryId : ""));
        return () => {
            dispatch(setUpdateTemplate({
                templateObj:{}
            }))
        }
    },[]);

    const updateLotteryData = (updateObj:any) => {
        let validatedObj = validateCreateOnetimeLottery(updateObj);
        if (validatedObj.status) {
            // dispatch(updateLottery(updateObj));
            dispatch(updateLotteryTemplate(updateObj));
            console.log(updateObj)
        } else {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: validatedObj.message
            }));
        }
    }

    const deleteTemplate = (obj:any) => {

        // console.log(obj)
        dispatch(removeTemplate({templateId:obj.lotteryId}));

    }

    let view  = Object.keys(templateObj).length > 0 ? 
    <>
    <Breadcrumbs>
    <ViewHeader title={`Update lottery`} isBackButtonRequired={true} backButtonRedirectionUrl={adminRouts.gamesList} />
    <DeleteBtn onClick={() => {deleteTemplate(templateObj)}}>
    Delete
        {/* <DeleteBtn title={"Delete1"} btnSize={ButtonSize.md} btnVariant={ButtonVariant.secondary} 
     clicked={() => {deleteTemplate(templateObj)}} />  */}
     </DeleteBtn>
    </Breadcrumbs>
    
    <UpdateTemplateForm onCreateLottery={updateLotteryData} onCancel={() => {navigateToView(adminRouts.gamesList)}} templateDetail={templateObj} /> 
    </>:
     <div>Please wait</div>

    return view;
};

export default UpdateOneTimeTemplate